import _ from 'lodash';

export const getUUID = () => crypto.randomUUID();

export const extendObjWithUUID = obj => {
  if (!_.isObject(obj)) {
    return obj;
  }

  return { ...obj, id: getUUID() };
};

const reverseHexBytes = hex => (hex.match(/../g) ?? []).reverse().join('');

/**
 * Sort key that orders GUID strings the way SQL Server orders uniqueidentifier values:
 * the last group first, then the fourth, then the first three groups byte-swapped.
 */
export const getSqlServerGuidSortKey = guid => {
  const [first = '', second = '', third = '', fourth = '', last = ''] = _.toLower(guid).split('-');

  return [last, fourth, ...[third, second, first].map(reverseHexBytes)].join('');
};
